/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PasskeyRegistrationVerifyForm { 
    /**
     * Attestation object WebAuthn, codificato in Base64URL
     */
    attestation_object: string;
    /**
     * Client data JSON WebAuthn, codificato in Base64URL
     */
    client_data_json: string;
    /**
     * Nome descrittivo del dispositivo (es. 'iPhone di Mario')
     */
    display_name?: string;
    /**
     * Refresh token KC offline da associare alla passkey
     */
    refresh_token: string;
}